import 'bootstrap/dist/css/bootstrap.min.css';
import './src/styles/highlight-darcula.css';
import '@fortawesome/fontawesome-svg-core/styles.css';

import './src/styles/default.css';
import './src/styles/style.css';
import './src/styles/responsive.css';

export const onClientEntry = () => {
  const params = new URLSearchParams(window.location.search);
  const affiliateRef = params.get('affiliate_ref');

  if (affiliateRef) {
    document.cookie = `affiliate_ref=${affiliateRef}; domain=.html2pdf.app; path=/; max-age=2592000; SameSite=Lax`;
  }
};
